module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img240-06c31a2fa63cab3a923434914ac711e8.jpg";